import { Button } from "components/Button/Button";
import { ValidatePropertyKeyProps } from "components/Form/components/SchemaForm/components/SchemaFormPropertKeyField";
import {
    getDefaultRequiredValue,
    getUpdatedData,
} from "components/Form/components/SchemaForm/SchemaFormService";
import { Text } from "components/Form/components/Text/Text";
import { Popover } from "components/Popover/Popover";
import { useRef, useState } from "react";
import styles from "./SchemaFormObjectKeyPopover.module.scss";

export interface SchemaFormObjectKeyPopoverProps {
    formSchema: any; // TODO evaluate improvement
    elementSchema: any; // TODO evaluate improvement
    formData: any; // TODO evaluate improvement
    elementData: any; // TODO evaluate improvement
    dataPath: any; // TODO evaluate improvement
    setData: (data: any) => void; // TODO evaluate improvement
    isDisabled: boolean;
    findSchema: (value: ValidatePropertyKeyProps) => any;
    additionalPropertyLabel: string;
}

export const SchemaFormObjectKeyPopover = ({
    formSchema,
    elementSchema,
    formData,
    elementData,
    dataPath,
    setData,
    isDisabled,
    findSchema,
    additionalPropertyLabel,
}: SchemaFormObjectKeyPopoverProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState<string | undefined>(undefined);
    const textRef = useRef<HTMLInputElement>() as React.MutableRefObject<HTMLInputElement>;

    const setNewValue = (propertyKey, foundSchema) => {
        const newValue = {
            ...(elementData ?? {}),
            [propertyKey]: getDefaultRequiredValue(formSchema, foundSchema, null),
        };
        if (newValue[propertyKey]?.hasOwnProperty("label")) {
            newValue[propertyKey].label = propertyKey;
        }
        setData(getUpdatedData(formData, dataPath, newValue));
        setError(undefined);
        setIsOpen(false);
    };

    const onAdd = () => {
        const propertyKey = textRef.current.value;
        const foundSchema = findSchema({ propertyKey, setError });
        if (foundSchema) {
            setNewValue(propertyKey, foundSchema);
        }
    };

    return (
        <Popover
            trigger={
                <Button
                    onClick={(event) => {
                        setIsOpen(true);
                        event.stopPropagation();
                    }}
                    label={`+ Add  ${additionalPropertyLabel}`}
                    variation="white"
                    size="small"
                    disabled={isDisabled}
                />
            }
            contentClassName={styles.SchemaFormObjectKeyPopover}
            rootClassName={styles.SchemaFormObjectKeyPopoverOverlay}
            closeOnInsideClick={false}
            isOpen={isOpen}
            closeHandler={() => {
                setIsOpen(false);
                setError(undefined);
            }}
        >
            <div className={styles.text}>{`Please enter a unique ${additionalPropertyLabel}`}</div>
            <Text
                reference={textRef}
                name={`${elementSchema.label} new key input`}
                autoFocus
                errorMessage={error}
                onEnterKey={onAdd}
            />
            <div className={styles.addButtonWrapper}>
                <Button variation="primary"
                    className={styles.addButton}
                    label={`Add ${additionalPropertyLabel}`}
                    onClick={onAdd}
                ></Button>
            </div>
        </Popover>
    );
};
